// Opens the support chat from anywhere, e.g. the in-call More menu, where the floating
// help button is hidden so it does not cover the call controls.
export const SUPPORT_OPEN_EVENT = 'televu:open-support'

export const openSupportChat = () => window.dispatchEvent(new Event(SUPPORT_OPEN_EVENT))
